<template>
  <span>
    <button @click="btnClickedHandler()" />
  </span>
</template>

<script>
export default {
  name: 'BtnCellRenderer',
  mounted() {},
  methods: {
    // Write your function here
  }
}
</script>
